var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 31,
    viewBox: "0 0 56 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.2676 6.59094C32.314 6.59094 28.7808 8.61484 28.7808 12.3541C28.7808 16.6424 35.047 16.9385 35.047 19.0928C35.047 19.9999 33.9944 20.8119 32.1967 20.8119C29.6455 20.8119 27.7386 19.6773 27.7386 19.6773L26.9227 23.4507C26.9227 23.4507 29.1194 24.4091 32.0358 24.4091C36.3583 24.4091 39.7597 22.2858 39.7597 18.4826C39.7597 13.9513 33.4674 13.6639 33.4674 11.6644C33.4674 10.9537 34.3314 10.1752 36.124 10.1752C38.1465 10.1752 39.7967 11.0003 39.7967 11.0003L40.5952 7.35594C40.5952 7.35594 38.7997 6.59094 36.2676 6.59094ZM0.0957571 6.86602L0 7.41611C0 7.41611 1.66332 7.71673 3.16138 8.31648C5.09023 9.00414 5.22768 9.4045 5.55252 10.6479L9.09241 24.1254H13.8378L21.1483 6.86602H16.4139L11.7164 18.6008L9.79961 8.65381C9.62381 7.51542 8.73335 6.86602 7.6434 6.86602H0.0957571ZM23.0521 6.86602L19.3381 24.1254H23.8528L27.5537 6.86596H23.0521V6.86602ZM48.2321 6.86602C47.1434 6.86602 46.5666 7.44165 46.1433 8.44755L39.529 24.1254H44.2635L45.1795 21.5124H50.9474L51.5044 24.1254H55.6818L52.0374 6.86602H48.2321ZM48.8478 11.529L50.2511 18.0055H46.4914L48.8478 11.529Z",
    fill: "#1434CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.bb58d662c37355fda4a9bfff8fb0bacb.svg";
export { ForwardRef as ReactComponent };